import { Link } from "react-router-dom";
import type { Work } from "@/types";
import HighlightText from "./HighlightText";

interface WorkCardProps {
  work: Work;
  query?: string;
}

export default function WorkCard({ work, query = "" }: WorkCardProps) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-300 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title} 舒淇影视作品海报`}
          title={`${work.title} 舒淇影视作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-foreground-950/70 text-background-50 text-[11px] font-label backdrop-blur-sm">
          {work.type}
        </span>
        <span className="absolute top-3 right-3 px-2 py-1 rounded-md bg-accent-500 text-background-50 text-[11px] font-medium">
          {work.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-1">
          <HighlightText text={work.title} query={query} />
        </h3>
        <p className="mt-1 text-xs text-secondary-500 tracking-wide">{work.enTitle}</p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1.5">
            <i className="ri-calendar-line" />
            {work.year}
          </span>
          <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700">
            {work.genre}
          </span>
        </div>
      </div>
    </Link>
  );
}